export const getTweetId = (data: { url?: string; id?: string }) => {
  return data.id || data.url?.split('status/')[1]?.split('?')[0]
}
